/**
 * ISBNs are stored digits-only (e.g. "9786060096016") so search and
 * duplicate-matching don't have to care how the user typed or pasted it —
 * hyphens, spaces, "ISBN" prefixes, whatever a barcode scanner or a manual
 * copy-paste from a book's back cover throws in are all stripped.
 */
export function normalizeIsbn(input: string): string {
  return input.replace(/\D/g, "").slice(0, 13);
}

/**
 * Display-only grouping (3-3-3-3-1, e.g. "978-606-009-601-6") — the pattern
 * Romanian textbook ISBNs (EAN prefix 978 + registration group 606) are
 * printed in. Not a certified re-derivation of the official ISBN hyphen
 * positions (that requires the international registrant-range table), just
 * a readable approximation for a school inventory, applied progressively so
 * it also looks right while still typing.
 */
export function formatIsbn(digitsOnly: string): string {
  const groupLengths = [3, 3, 3, 3, 1];
  const parts: string[] = [];
  let i = 0;
  for (const len of groupLengths) {
    if (i >= digitsOnly.length) break;
    parts.push(digitsOnly.slice(i, i + len));
    i += len;
  }
  return parts.join("-");
}
